<script setup lang="ts">
import "./MItemSection.scss";
import { computed } from "vue";
import type { MItemSectionProps } from "./MItemSection.props";
import { mItemSectionDefaults } from "./MItemSection.props";

const props = withDefaults(defineProps<MItemSectionProps>(), mItemSectionDefaults);

const classes = computed(() => ["m-item-section", props.avatar && "m-item-section--avatar"]);
</script>

<template>
  <div :class="classes">
    <slot />
  </div>
</template>
